import React from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'react-router'
import Breadcrumbs from 'react-breadcrumbs'
import NotificationsChannel from './notifications/notifications'
import get from 'lodash/get'
import { connect } from 'react-redux'
import premiumAccess from '../images/premium3.png'

const BreadcrumbBack = ({ pathname, onClick }) => (
  (pathname && pathname.split(/\//).length > 1) ? <img height="25px" src={(require('../images/back-arrow.svg'))} style={{cursor: 'pointer', marginRight: '5px'}} onClick={onClick} />
    : null
)

class Main extends React.Component {
  createBadges (path, active) {
    const { unreadNotification: { inProgress }, totalIssues } = this.props

    let badges = []

    if (path === 'in-progress' && inProgress > 0 && !active) {
      badges.push(
        <span className='badge'>
          {inProgress}
        </span>
      )
    }

    if (path === 'location-issues' && totalIssues) {
      badges.push(
        <span className='badge' key="permanent">
          {totalIssues.permanent}
        </span>
      )

      badges.push(
        <span className='badge needs-review' key="needsReview">
          {totalIssues.needsReview}
        </span>
      )

      badges.push(
        <span className='badge needs-work' key="needsWork">
          {totalIssues.needsWork}
        </span>
      )
    }

    return badges
  }

  renderNavLinks (link, i) {
    const { location } = this.props
    const badges = this.createBadges(link.path, active)
    let active = (location.pathname.includes(link.path))
    let props = {}
    let premiumImg = null
    if (link.disabled) {
      props.className = `${link.path} disabled`
      premiumImg = (<img src={premiumAccess} className='premium' alt='premiumAccess' width={18} height={18} />)
    } if (link.issuesDisabled) {
      props.className = `${link.path} disabled`
    } else {
      props.to = `/${link.path}`
      if (active) {
        props.className = `${link.path} active`
      } else {
        props.className = `${link.path}`
      }
    }
    return (
      <Link
        {...props}
        textAlignVertical='center'
        key={i}>
        {link.title}
        { (link.disabled) ? ((link.issuesDisabled) ? badges : null) : badges }
        { premiumImg }
      </Link>
    )
  }

  shouldComponentUpdate (props) {
    ReactDOM.findDOMNode(this.refs.main).scrollTop = 0
    return true
  }

  render () {
    const disabledFields = this.props.userType === 'Supervisor'
    const links = [
      { path: 'work-orders', title: 'Work Orders' },
      { path: 'in-progress', title: 'In Progress' },
      { path: 'summaries', title: 'Daily Work Sheet Summary' },
      { path: 'calendar', title: 'Calendar', disabled: disabledFields },
      { path: 'location-issues', title: 'Issues', disabled: disabledFields, issuesDisabled: this.props.userType === 'Technician' },
      { path: 'work-tracker', title: 'Work Tracker Reports' },
      { path: 'inspections', title: 'Inspections List', disabled: disabledFields },
      { path: 'settings', title: 'Settings' }
    ]

    const { logout, routes, goBack, location } = this.props

    return (
      <div>
        <section className='navigation'>
          <div className='maats-icon' />
          <nav className='navigation-links'>
            {links.map(this.renderNavLinks.bind(this))}
          </nav>
          <button onClick={logout} className='logout-button'>Logout</button>
        </section>
        <Breadcrumbs
          separator=' / '
          routes={routes}
          params={this.props.params}
          displayMissing={false}
          excludes={[
            'mainContainer',
            'createWorkOrder',
            'editWorkOrder',
            'addAreaWorkOrder',
            'createPin',
            'updatePin',
            'createQAWorkOrder',
            'qaServicingWrapper',
            'createQAServicing'
          ]}
          prepend={<BreadcrumbBack pathname={location.pathname} onClick={goBack}/>}
        />
        <NotificationsChannel />
        <main ref='main' className='content-container'>
          {this.props.children}
        </main>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  const userType = get(state.auth, 'session.type')

  return {
    userType
  }
}

export default connect(mapStateToProps)(Main)



// WEBPACK FOOTER //
// ./src/components/main.js